import { Chip, createStyles, makeStyles, Theme } from '@material-ui/core';
import React from 'react';

import { spacings } from '../../../theme';

type Props = {
  labels: Array<{ __typename?: 'Label'; id: string; name: string }>;
};

export function CardLabels({ labels }: Props): React.ReactElement {
  const classes = useStyles();
  return (
    <>
      {labels.map((label) => (
        <Chip key={label.id} size="small" label={label.name} className={classes.label} />
      ))}
    </>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    labelContainer: {
      marginLeft: spacings.small,
    },
    label: {
      margin: '2px',
      verticalAlign: 'top',
    },
  })
);
